import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import project1 from '../../assets/images/project1.jpg';
import project2 from '../../assets/images/project2.jpg';
import project3 from '../../assets/images/project3.jpg';

const options = {
    infinite: true,
    arrows: false,
    dots: true,
    speed: 2000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3 } },
        { breakpoint: 786, settings: { slidesToShow: 2 } },
        { breakpoint: 576, settings: { slidesToShow: 1 } },
    ]
}

class Project extends React.Component {
    render(){
        return (
            <section id="project" className="project-area uk-project uk-section">
                <div className="uk-container">
                    <div className="uk-section-title section-title">
                        <span>Our Completed Projects</span>
                        <h2>Recent Work</h2>
                        <div className="bar"></div>
                    </div>
                </div>

                <Slider
                    className="project-slides"
                    {...options}
                >
                    <div className="single-project">
                        <div className="project-img">
                            <img src={project1} alt="AI-Powered CRM Platform" />
                        </div>
                        <div className="project-content">
                            <h3>AI-Powered CRM Platform</h3>
                            <ul>
                                <li>Web App</li>
                                <li>AI / ML</li>
                            </ul>
                        </div>
                    </div>

                    <div className="single-project">
                        <div className="project-img">
                            <img src={project2} alt="Fintech Mobile Application" />
                        </div>
                        <div className="project-content">
                            <h3>Fintech Mobile Application</h3>
                            <ul>
                                <li>Mobile</li>
                                <li>React Native</li>
                            </ul>
                        </div>
                    </div>

                    <div className="single-project">
                        <div className="project-img">
                            <img src={project3} alt="Cloud Migration & DevOps" />
                        </div>
                        <div className="project-content">
                            <h3>Cloud Migration & DevOps</h3>
                            <ul>
                                <li>Cloud</li>
                                <li>AWS</li>
                            </ul>
                        </div>
                    </div>

                    <div className="single-project">
                        <div className="project-img">
                            <img src={project1} alt="ML Analytics Dashboard" />
                        </div>
                        <div className="project-content">
                            <h3>ML Analytics Dashboard</h3>
                            <ul>
                                <li>Data</li>
                                <li>Machine Learning</li>
                            </ul>
                        </div>
                    </div>

                    <div className="single-project">
                        <div className="project-img">
                            <img src={project3} alt="Enterprise ERP System" />
                        </div>
                        <div className="project-content">
                            <h3>Enterprise ERP System</h3>
                            <ul>
                                <li>Web App</li>
                                <li>Enterprise</li>
                            </ul>
                        </div>
                    </div>
                </Slider>
            </section>
        );
    }
}

export default Project;
